import { render, staticRenderFns } from "./AddSignature.vue?vue&type=template&id=9a8d563c&scoped=true&"
import script from "./AddSignature.vue?vue&type=script&lang=js&"
export * from "./AddSignature.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=9a8d563c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8d563c",
  null
  
)

export default component.exports